import type { GetPublicListingError, GetPublicListingResponse } from './types'

import { createAsyncThunk } from '@reduxjs/toolkit'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { draftedListingAPIInstance, publicListingAPIInstance, reviewListingAPIInstance } from 'api'

import { NAME } from './constant'

interface IListing {
  slug: string
}

export const getPublicListing = createAsyncThunk(
  `${NAME}/GET_PUBLIC_LISTING`,
  async ({ slug }: IListing, { rejectWithValue }) => {
    try {
      const response = await publicListingAPIInstance.get<unknown, GetPublicListingResponse>(
        `/listing-creation/${slug}/public`,
      )
      return response
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const errorData = error?.data as unknown as GetPublicListingError
      return rejectWithValue(errorData)
    }
  },
)

export const getDraftedListing = createAsyncThunk(
  `${NAME}/GET_DRAFTED_LISTING`,
  async ({ slug }: IListing, { rejectWithValue }) => {
    try {
      const response = await draftedListingAPIInstance.get<unknown, GetPublicListingResponse>(
        `/listing-creation/${slug}/preview`,
      )
      return response
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const errorData = error?.data as unknown as GetPublicListingError
      return rejectWithValue(errorData)
    }
  },
)

export const getReviewListing = createAsyncThunk(
  `${NAME}/GET_REVIEW_LISTING`,
  async ({ slug }: IListing, { rejectWithValue }) => {
    try {
      const response = await reviewListingAPIInstance.get<unknown, GetPublicListingResponse>(
        `/listing-creation/${slug}/review`,
      )
      return response
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const errorData = error?.data as unknown as GetPublicListingError
      return rejectWithValue(errorData)
    }
  },
)

export const asyncActions = {
  getPublicListing,
  getDraftedListing,
  getReviewListing,
}
